// app/frontend/pages/Onboarding/stepConfigs.tsx
import { IconSparkles, IconStar, IconMapPin, IconTarget, IconCheck } from "@tabler/icons-react";
import { StepConfig } from "../../components/ui/Stepper";
import { OnboardingFormValues } from "./types";
import {
  StepWelcome,
  StepSkillLevel,
  StepLocation,
  StepGoals,
  StepComplete,
} from "./steps";

export const stepConfigs: StepConfig<OnboardingFormValues>[] = [
  {
    id: "welcome",
    title: "Welcome",
    component: StepWelcome,
    icon: IconSparkles,
  },
  {
    id: "skill-level",
    title: "Skill Level",
    component: StepSkillLevel,
    icon: IconStar,
  },
  {
    id: "location",
    title: "Location",
    component: StepLocation,
    icon: IconMapPin,
  },
  {
    id: "goals",
    title: "Goals",
    component: StepGoals,
    icon: IconTarget,
  },
  {
    id: "complete",
    title: "Complete",
    component: StepComplete,
    icon: IconCheck,
  },
];
